import { render } from "./MyAdDetail.vue?vue&type=template&id=61a739bd&scoped=true"
import script from "./MyAdDetail.vue?vue&type=script&lang=js"
export * from "./MyAdDetail.vue?vue&type=script&lang=js"

import "./MyAdDetail.vue?vue&type=style&index=0&id=61a739bd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61a739bd"]])

export default __exports__